var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tt-card flower-card"},[_c('div',{staticClass:"px-4 pt-4 text-center"},[_c('h4',[_vm._v(_vm._s(_vm.name))])]),_vm._l((_vm.flowers),function(flower){return _c('flower-row',{key:flower.name,attrs:{"flower":flower}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }